export default function useNumber() {
  const resolveNumber = (number: number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  return {
    resolveNumber,
  };
}
